import { createReducer } from '@ngrx/store';

export const initialState = {};

export const discrepancyReducer = createReducer(initialState);
